import {getCurrentYear} from '../../utils/commons'
import TopStatesReviewsLogo from './logo'
import {topStatesReviewsStylesUS} from './styles'

const baseConfig = {
  domainName: 'topstatesreviews' as const,
  domainType: 'maga' as const,
  siteName: 'Top States Reviews',
  logo: <TopStatesReviewsLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/topstatesreviews.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-FWYLME569X',
    camelCaseUrl: 'TopStatesReviews.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | TopStatesReviews.com - Pro Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the most trusted product picks for Americans at TopStatesReviews.com. Our expert reviews highlight gear and gadgets with USA-worthy value, state by state.`,
    styles: topStatesReviewsStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
